import { Link, NavLink } from "react-router-dom";
import styled from "styled-components/macro";
import { FC, useState } from "react";
import Theme from "../constants/Theme";
import { DPIconClose, DPIconMenu } from "../assets/icons";
import { navLinksType } from "./index";
import Modal from "../atoms/Modal";
import media from "../constants/MediaQuery";
import useOnClickOutside from "../hooks/outsideClick";
import { CareerForm } from "../molecules/CareerForm";

const LandingNavbar: FC<{ navLinks: navLinksType }> = ({ navLinks }) => {
  const {
    visible: showMenus,
    setVisible: setShowMenus,
    ref,
  } = useOnClickOutside(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleShowMenus =
    (state: boolean = false) =>
    () => {
      setShowMenus(state);
    };

  return (
    <LandingNavbarStyling showMenus={showMenus}>
      {showMenus && (
        <div
          role="presentation"
          className=" LN__LNS_sidebar--overlay "
          onClick={toggleShowMenus(false)}
        />
      )}
      <div className="LN__LNS_sidebar">
        <div className="LN__LNS_sidebar--content">
          <div className="LN__LNS_sidebar--content--sidebar-header">
            <div className="LN__LNS_sidebar--content--sidebar-header--close">
              <DPIconClose onClick={toggleShowMenus(false)} />
            </div>
            <div className="LN__LNS--logo-div">
              <Link to="/">
                <img
                  className="LN__LNS--logo"
                  src="./assets/images/main-logo.svg"
                  alt="dotpay"
                />
              </Link>
            </div>
          </div>
          <div>
            {navLinks.map(({ label, link }, index) => {
              return (
                <NavLink
                  exact
                  activeClassName="LN__LNS--menus-menu--active"
                  key={index.toString()}
                  className="LN__LNS--menus-menu"
                  to={link}
                >
                  {label}
                </NavLink>
              );
            })}
            <a
              className="LN__LNS--menus-menu"
              href="https://app.dotpay.africa/"
            >
              LOGIN
            </a>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="LN__LNS">
          <Link to="/">
            <img
              className="LN__LNS--logo"
              src="./assets/images/main-logo.svg"
              alt="dotpay"
            />
          </Link>
          <nav ref={ref} className="LN__LNS--menus">
            {navLinks.map(({ label, link }, index) => {
              return (
                <NavLink
                  onClick={() => {
                    if (link === "/career") {
                      setIsOpen(true);
                    }
                  }}
                  exact
                  activeClassName="LN__LNS--menus-menu--active"
                  key={index.toString()}
                  className="LN__LNS--menus-menu"
                  to={link}
                >
                  {label}
                </NavLink>
              );
            })}
            <a
              className="LN__LNS--menus-menu"
              href="https://app.dotpay.africa/"
            >
              LOGIN
            </a>
          </nav>
          <DPIconMenu
            className="LN__LNS--menu-toggle"
            onClick={toggleShowMenus(true)}
          />
        </div>
      </div>
      <Modal
        // width="max-content"
        // height="max-content"
        showModal={isOpen}
        onBackdropClick={() => setIsOpen(!isOpen)}
        onCloseClick={() => setIsOpen(!isOpen)}
        maxModal={[600, 400]}
      >
        <CareerForm />
      </Modal>
    </LandingNavbarStyling>
  );
};

const LandingNavbarStyling = styled.nav<{ showMenus: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${Theme.colorPalette.landingBackground};
  padding: 20px 0;

  .container {
    position: relative;
  }

  .LN__LNS {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &_sidebar {
      transition: all 0.4s;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 4;
      transform: ${({ showMenus }) =>
        showMenus ? "translateX(0%)" : "translate(-100%)"};

      &--overlay {
        background: #0000001f;
        height: 100%;
        width: 100%;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
      }

      &--content {
        max-width: 325px;
        min-width: 250px;
        width: 80%;
        background: white;
        z-index: 5;
        position: absolute;
        top: 0;
        height: 100%;

        &--sidebar-header {
          display: flex;
          flex-direction: column;

          &--close {
            display: flex;
            justify-content: flex-end;
            padding: 20px 20px 0 0;
          }
        }
      }
    }

    &--logo-div {
      padding: 40px 0 40px 40px;
    }

    &--logo {
      height: 40px;
    }

    &--menu-toggle {
      display: block;
      cursor: pointer;
    }

    &--menus {
      //transition: height 0.5s;
      background: white;
      position: absolute;
      top: 60px;
      left: 0;
      right: 0;
      height: 0;
      z-index: 1;
      overflow: hidden;
      display: flex;
      gap: 50px;

      &--active {
        height: 100vh;
        width: 80%;
        position: fixed;
        z-index: 2;
        top: 0;
        box-shadow: 0 5px 5px 0 #0000001c;
      }

      &-menu {
        display: block;
        /* padding: 30px 0 30px 50px; */
        color: ${Theme.colorPalette.matteBlack};
        text-transform: uppercase;
        font-family: ${Theme.typography.secondary};
        font-weight: ${Theme.fontWeights.medium};
        // border-bottom: 1px solid ${Theme.colorPalette.textGrey};
        &--active {
          color: ${Theme.colorPalette.darkBlue};
        }

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          color: white;
          background: ${Theme.colorPalette.darkBlue};
        }
      }
    }
  }

  ${media.tabletMin`
   height: 130px;
    padding: unset;
    .LN__LNS {
      &--logo {
        height: 50px;
      }
      &_sidebar, &_sidebar--overlay {
        display:none;
      }
      &--logo-div{display:none;}
      &--close{display:none;}
      &--menu-toggle {
        display: none;
      }
      &--menus--active{display:none;}
      
      &--menus {
        position: relative;
        top: unset;
        left: unset;
        right: unset;
        height: unset;
        overflow: unset;
        background: unset;
        &-menu {
          display: inline-block;
          border: none;
          border-bottom: 2px solid transparent;
           &:hover {
              font-weight: 600;
              color: #055445;
             background: unset;
             border-bottom: 2px solid #055445;
           }

           &--active {
            border-bottom: 2px solid #055445;

           }
        }
      }
    }
  `}
`;

export default LandingNavbar;
